import React from "react";
import "./styles.styl";

const LoadingSpinner = ({
  isLoading,
  children,
  clazzName,
  applyStylesToMain = true,
}) => {
  if (isLoading) {
    return (
      <div className={`loading_spinner__main ${clazzName}`}>
        <div className="loading_spinner__container">
          <div className="loading_spinner__spinner_style"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`loading_spinner__main ${applyStylesToMain && clazzName}`}>
      {children}
    </div>
  );
};

export default LoadingSpinner;
